import Vue from 'vue'
import Router from 'vue-router'
import Cookies from "js-cookie"
import login from '@/views/login'
import home from '@/views/home'
import user from '@/views/user'
import homepage from '@/views/homepage'
import notFound from '@/views/404'
import integralItem from "@/views/integralItem";
import propaganda from "@/views/propaganda";

Vue.use(Router);

const router = new Router({
    routes: [
        {
            path: '/',
            name: '首页',
            component: home,
            redirect: '/homepage',
            children: [
                {path: '/homepage', component: homepage, name: '首页'},
                {path: '/user', component: user, name: '用户管理'},
                {path: '/integralItem', component: integralItem, name: '积分历史'},
                {path: '/propaganda', component: propaganda, name: '合作伙伴'},
            ]
        },
        {
            path: '/login',
            name: '登录',
            component: login
        },
        {
            path: '/404',
            name: 'notFound',
            component: notFound
        }
    ],
    mode: "hash"
});

router.beforeEach((to, from, next) => {
    let userInfo = Cookies.get('userInfo');
    if (to.path === '/login') {
        if (userInfo) {
            next({path: '/'})
        } else {
            next()
        }
    } else {
        if (!userInfo) {
            next({path: '/login'})
        } else {
            next()
        }
    }
});

const routerPush = Router.prototype.push;
Router.prototype.push = function push(location) {
    return routerPush.call(this, location).catch(error => error)
};

export default router